import React, { useState } from 'react';
import { Gift, Sparkles, ChevronDown, ChevronUp } from 'lucide-react';
export function GuaranteeBox() {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="bg-white border-2 border-[#D4AF37] rounded-xl p-8 text-center" data-id="element-31">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-[#D4AF37] rounded-full mb-6" data-id="element-32">
        <Gift className="w-10 h-10 text-white" data-id="element-33" />
      </div>

      <h3 className="text-2xl md:text-3xl font-bold text-[#8B7355] mb-4 flex items-center justify-center gap-2" data-id="element-34">
        <Sparkles className="w-6 h-6 text-[#D4AF37]" data-id="element-35" />
        BONO GRATIS INCLUIDO
      </h3>

      <h4 className="text-xl md:text-2xl font-semibold text-[#D4AF37] mb-6" data-id="element-36">
        21 Recetas de Limpieza Express en 5 Minutos
      </h4>

      <div className="mb-8" data-id="element-37">
        <img src="https://cdn.magicpatterns.com/uploads/nNomRYwXd8DTXVZnCmLJ4x/21recetas-express-colorcrema.png" alt="21 Recetas de Limpieza Express" className="w-full max-w-lg mx-auto rounded-lg shadow-xl" data-id="element-38" />
      </div>

      <button onClick={() => setIsExpanded(!isExpanded)} className="text-[#D4AF37] font-semibold text-lg hover:text-[#C4A027] transition-colors flex items-center gap-2 mx-auto mb-6" data-id="element-39">
        Leer más
        {isExpanded ? <ChevronUp className="w-5 h-5" data-id="element-40" /> : <ChevronDown className="w-5 h-5" data-id="element-41" />}
      </button>

      {isExpanded && <div className="text-left max-w-3xl mx-auto space-y-4" data-id="element-42">
          <p className="text-lg text-[#3A3226] leading-relaxed" data-id="element-43">
            Hija querida, este ebook,{' '}
            <span className="font-semibold" data-id="element-44">
              21 Recetas de Limpieza Express en 5 Minutos
            </span>
            , es mi manera de acompañarte cuando la casa se pone movida: cuando
            hay derrames, olores raros, manchas nuevas o esas visitas que llegan
            sin avisar. Todo con cosas sencillas que ya tienes en casa.
          </p>

          <p className="text-lg text-[#3A3226] leading-relaxed" data-id="element-45">
            En estas páginas te enseño 21 recetas rápidas y sin químicos
            fuertes. Son soluciones que funcionan en minutos y que te devuelven
            la calma cuando el caos quiere asomarse.
          </p>

          <p className="text-xl text-center font-semibold text-[#D4AF37] mt-6 italic" data-id="element-46">
            Mi niña, este es tu manual para salir de apuros sin estrés, sin
            gastar de más y con el cariño de siempre. Porque cuando la vida te
            sorprende… aquí estoy yo para salvarte en 5 minutos.
          </p>
        </div>}
    </div>;
}